<template>
  <div>
    <div>
      <el-table
        v-if="value"
        :data="unifiedTableData"
        style="width: 100%"
        border
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="description" label="Description" width="300">
        </el-table-column>
        <el-table-column prop="unitPrice" label="Unit price"> </el-table-column>
        <el-table-column prop="qty" label="Quantity per week">
        </el-table-column>
        <el-table-column prop="weeks" label="Weeks"> </el-table-column>
        <el-table-column prop="total" label="Total"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { upperFirst } from 'lodash'

export default {
  props: ['value'],
  computed: {
    packagePrices() {
      const prices = Array.isArray(this.value.package_price)
        ? this.value.package_price
        : [this.value.package_price]

      if (prices.length === 1) {
        return Array(this.value.duration).fill(prices[0])
      }

      return prices
    },
    packageUnitPrice() {
      if (this.packagePrices.length === 1) {
        return this.packagePrices[0]
      }
      return this.packagePrices.join(', ')
    },
    packageTotalPrice() {
      if (this.value.package_total_price != null) {
        return this.value.package_total_price
      }
      return this.packagePrices.reduce((sum, price) => sum + price, 0)
    },
    trainingRowsDiscount() {
      const trainingTotal = (this.value.lessons.training || []).reduce(
        (sum, item) => sum + item.price * item.amount * this.value.duration,
        0
      )
      return Math.min(
        trainingTotal,
        this.value.special_training_discount_price || 0
      )
    },
    unifiedTableData() {
      let rows
      const packageRow = {
        description: `Package - ${this.value.package_name} (${this.value.duration} weeks)`,
        unitPrice: this.packageUnitPrice,
        qty: 1,
        weeks: this.value.duration,
        total: this.packageTotalPrice
      }
      const airportServiceRow = {
        description: `Airport service`,
        unitPrice: this.value.airport_service_price,
        qty: 1,
        weeks: this.value.duration,
        total: this.value.airport_service_price
      }
      const flatLessons = [
        ...this.value.lessons.lesson,
        ...this.value.lessons.training
      ]
      const lessonsRows = flatLessons.map(item => ({
        description: `${upperFirst(item.type)} - ${item.name} (${
          item.amount
        } x per week)`,
        unitPrice: item.price,
        qty: item.amount,
        weeks: this.value.duration,
        total: item.price * item.amount * this.value.duration
      }))

      rows = [packageRow, ...lessonsRows]
      if (this.value.airport_service_price !== 0) {
        rows = [packageRow, airportServiceRow, ...lessonsRows]
      }
      if (this.value.special_training_discount_price) {
        const trainingDiscountRow = {
          description: `Training discount (2 trainings per week)`,
          unitPrice: -this.trainingRowsDiscount / this.value.duration,
          qty: 1,
          weeks: this.value.duration,
          total: -this.trainingRowsDiscount
        }
        rows = [...rows, trainingDiscountRow]
      }
      return rows
    }
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Duration (weeks)'
          return
        }

        if (index === 1) {
          sums[index] = this.value.duration
          return
        }

        if (index === 3) {
          sums[index] = 'Total Cost'
          return
        }
        if (index !== 4) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    }
  }
}
</script>
